import React from "react";

/**
 * Interpreta el importe tipeado con la MISMA lógica que parseAmount de mcb-api:
 * escritura LatAm (punto = miles, coma = decimal). "164.635,00" -> 164635 ·
 * "4.690" -> 4690 · "4690.50" -> 4690.5. Devuelve null si no se puede leer.
 */
export function interpretarImporte(v) {
  if (v === null || v === undefined) return null;
  let s = String(v).trim().replace(/[^0-9.,]/g, "");
  if (s === "") return null;

  if (s.includes(",")) {
    s = s.replace(/\./g, "").replace(",", ".");
  } else {
    const parts = s.split(".");
    if (parts.length > 2) {
      s = parts.join("");
    } else if (parts.length === 2 && parts[1].length === 3) {
      s = parts.join("");
    }
  }

  const n = parseFloat(s);
  return isNaN(n) ? null : n;
}

/**
 * Input de importe para informar pagos. Reemplaza a los <input type="number">:
 * en los teclados de celular el type=number DESCARTA la coma/punto en silencio
 * ("164635,00" quedaba "16463500" — monto x100). Acá es type=text con teclado
 * decimal, se preservan los separadores, y se muestra en vivo cómo se va a
 * interpretar el monto para que el cliente lo confirme visualmente.
 */
export default function ImporteField({ value, onChange, className }) {
  const handleChange = (e) => {
    // Solo dígitos, puntos y una única coma con hasta 2 decimales.
    let v = e.target.value.replace(/[^0-9.,]/g, "");
    const i = v.indexOf(",");
    if (i !== -1) {
      v = v.slice(0, i + 1) + v.slice(i + 1).replace(/[.,]/g, "").slice(0, 2);
    }
    onChange(v);
  };

  const n = interpretarImporte(value);

  return (
    <>
      <input
        className={className}
        type="text"
        inputMode="decimal"
        autoComplete="off"
        placeholder="Ej: 164.635,50"
        value={value}
        onChange={handleChange}
        required
      />
      {n !== null && n > 0 && (
        <div style={{ fontSize: 13, marginTop: 4, color: "#0071ce" }}>
          Vas a informar:{" "}
          <b>
            {n.toLocaleString("es-AR", {
              style: "currency",
              currency: "ARS",
              minimumFractionDigits: 2,
            })}
          </b>
        </div>
      )}
    </>
  );
}
